<main class="container principal-content">
    <div class="first-unauthorized-content">
        <img src="assets/images/error-404.svg" alt="" width="402px" height="314px">
        <h2>Ops! Você não tem permissão para acessar esse conteúdo!</h2>
        <h3>Retorne à página anterior ou, em caso de dúvidas, acesse a ajuda!</h3>
        <button (click)="goToAuth()">Voltar</button>
    </div>
</main>
